{
  "validation.required": "{{label}} è un campo obbligatorio",
  "validation.minLength": "{{label}} deve essere lungo almeno {{min}} caratteri",
  "validation.maxLength": "{{label}} non può essere più lungo di {{max}} caratteri",
  "validation.contentTypeAlphanumeric": "{{label}} deve essere alfanumerico",
  "validation.contentTypeDate": "{{label}} deve essere una data",
  "validation.contentTypeDateBefore": "{{label}} deve essere una data precedente a {{date beforeDate}}",
  "validation.contentTypeDateAfter": "{{label}} deve essere una data successiva a {{date afterDate}}",
  "validation.contentTypeDatetime": "{{label}} deve essere una data e un'ora",
  "validation.contentTypeDatetimeBefore": "{{label}} deve essere una data precedente a {{datetime beforeDate}}",
  "validation.contentTypeDatetimeAfter": "{{label}} deve essere una data successiva a {{datetime afterDate}}",
  "validation.contentTypeEmail": "{{label}} deve essere un'email",
  "validation.contentTypeInteger": "{{label}} deve essere un numero",
  "validation.contentTypeNumber": "{{label}} deve essere un numero",
  "validation.contentTypeRegex": "{{label}} ha il formato sbagliato",
  "validation.contentTypeText": "{{label}} deve essere un testo",
  "validation.contentTypeTime": "{{label}} deve essere un orario",
  "validation.contentTypeUrl": "{{label}} deve essere un indirizzo web",
  "select-element.default-option": "Selezionare…",
  "button-element.network-required": "Al momento sei offline. Stabilisci una connessione di rete per continuare."
}